import Vue from 'vue'
import Router from 'vue-router'

import { Dialog, Toast } from 'buefy'

// Layout
import Layout from '@/components/Layout'

// Pages
import Dashboard from '@/pages/dashboard/Dashboard'
import Auth from '@/pages/auth/Auth'

// Secure Routes
import UsersRoutes from '@/pages/users/routes'
import SetupRoutes from '@/pages/setup/routes'
import CostCenterRoutes from '@/pages/cost-center/routes'
import ProviderRoutes from '@/pages/provider/routes'
import ClientRoutes from '@/pages/client/routes'
import ExpenseRoutes from '@/pages/expense/routes'
import RevenueRoutes from '@/pages/revenue/routes'
import YieldRoutes from '@/pages/yield/routes'
import PaymentRoutes from '@/pages/payment/routes'
import ReportRoutes from '@/pages/reports/routes'
import BalanceRoutes from '@/pages/balance/routes'
import ProspectingCustomerRoutes from '@/pages/prospecting-customer/routes'
import PartnerRoutes from '@/pages/partner/routes'
import AccountRoutes from '@/pages/account/routes'

// Auth Service to guard routes.
import AuthService from '@/services/auth.js'

Vue.use(Router)

const securePages = {
  path: '',
  component: Layout,
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {hidden: true}
    },
    {...BalanceRoutes},
    {...ExpenseRoutes},
    {...RevenueRoutes},
    {...YieldRoutes},
    {...ProviderRoutes},
    {...ClientRoutes},
    {...CostCenterRoutes},
    {...PaymentRoutes},
    {...UsersRoutes},
    {...ReportRoutes},
    {...AccountRoutes},
    {...ProspectingCustomerRoutes},
    {...PartnerRoutes},
    {...SetupRoutes}
  ]
}

const routes = [
  {
    path: '/auth/:action?/:token?',
    name: 'Auth',
    component: Auth
  },
  {...securePages},

  // Redirect to Home
  {
    path: '*',
    redirect: {name: 'Dashboard'}
  }
]

const router = new Router({
  routes,
  linkActiveClass: 'is-active',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

let vueInstance = new Vue()
let loadingComponent

router.beforeEach((to, from, next) => {
  const isLoggedIn = AuthService.checkAuth()
  loadingComponent = vueInstance.$loading.open()

  if (to.matched[0].meta.requireAuth && !isLoggedIn) {
    loadingComponent.close()
    return next({name: 'Auth'})
  } else if (to.name === 'Auth' && isLoggedIn) {
    loadingComponent.close()
    return next({name: 'Dashboard'})
  } else if (to.meta && to.meta.requiredPermission) {
    AuthService.checkPermission(to.meta.requiredPermission.resource, to.meta.requiredPermission.value)
    .then(response => {
      return next()
    })
    .catch(response => {
      Dialog.alert('Você não possui permissão para acessar essa página!')
      loadingComponent.close()
      return next(false)
    })
  } else {
    return next()
  }
})

router.afterEach((to, from) => {
  loadingComponent.close()
})

router.onError(error => {
  loadingComponent.close()
  const data = JSON.parse(error.message)
  if (data) {
    if (data.next && data.label) {
      Toast.open({
        message: data.label,
        type: 'is-warning',
        duration: 5000
      })
    }
    if (data.next) return router.push(data.next)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js